import React from 'react';

import { useDeferredModule } from '@client/islands';

type ClientEffectsModule = typeof import('./ClientEffects');

const loadClientEffects = async (): Promise<ClientEffectsModule> => {
    return import('./ClientEffects');
};

export function DeferredClientEffects() {
    const { value: clientEffectsModule } = useDeferredModule(loadClientEffects, {
        when: 'idle',
        timeoutMs: 900,
    });

    return clientEffectsModule ? <clientEffectsModule.ClientEffects /> : null;
}
